var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { cache } from "./Cache";
export class ServerError extends Error {
    constructor(status, statusText, data) {
        super(`Server error - ${status}: ${statusText}`);
        this.status = status;
        this.statusText = statusText;
        this.data = data;
    }
}
function handleResponse(opts) {
    return __awaiter(this, void 0, void 0, function* () {
        const { response, deleteCacheUrl } = opts;
        const contentType = response.headers.get("content-type");
        let data;
        if (contentType && contentType.indexOf("application/json") !== -1) {
            data = response.json();
        }
        else {
            data = response.text();
        }
        if (!response.ok) {
            const resolvedData = yield data;
            if (deleteCacheUrl) {
                cache.delete(deleteCacheUrl);
            }
            throw new ServerError(response.status, response.statusText, resolvedData);
        }
        return data;
    });
}
const appId = generateUID();
export class API {
    static get(url, refreshCache = false, options = {}) {
        const cachedResult = cache.get(url);
        if (cachedResult && !refreshCache) {
            return cachedResult;
        }
        const promise = fetch(API.getBaseUrl(url) + url, Object.assign({ credentials: "include", headers: {
                "Content-Type": "application/json",
                "x-app-id": appId,
            } }, options)).then((response) => handleResponse({ response, deleteCacheUrl: url }));
        return cache.set(url, promise);
    }
    static postFormData(url, data, options = {}) {
        return fetch(API.getBaseUrl(url) + url, Object.assign({ method: "POST", credentials: "include", headers: {
                "x-app-id": appId,
            }, body: data }, options)).then((response) => handleResponse({ response }));
    }
    static post(url, data, options = {}) {
        return fetch(API.getBaseUrl(url) + url, Object.assign({ method: "POST", credentials: "include", headers: {
                "Content-Type": "application/json",
                "x-app-id": appId,
            }, body: JSON.stringify(data) }, options)).then((response) => handleResponse({ response }));
    }
    static put(url, data, options = {}) {
        return fetch(API.getBaseUrl(url) + url, Object.assign({ method: "PUT", credentials: "include", headers: {
                "Content-Type": "application/json",
                "x-app-id": appId,
            }, body: JSON.stringify(data) }, options)).then((response) => handleResponse({ response }));
    }
    static delete(url, data, options = {}) {
        return fetch(API.getBaseUrl(url) + url, Object.assign({ method: "DELETE", credentials: "include", headers: {
                "Content-Type": "application/json",
                "x-app-id": appId,
            }, body: JSON.stringify(data) }, options)).then((response) => handleResponse({ response }));
    }
    static getBaseUrl(url) {
        if (url.indexOf("http") === 0) {
            return "";
        }
        return process.env.REACT_APP_API || "http://localhost:9876";
    }
}
function generateUID() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
        var r = (Math.random() * 16) | 0, v = c === "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}
